import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  Divider,
  Stack,
  Button,
  Grid
} from "@mui/material";
import {
  Print as PrintIcon,
  QrCode2 as QrCodeIcon,
  Receipt as ReceiptIcon,
  AccountBalance as AccountBalanceIcon,
  Person as PersonIcon,
} from "@mui/icons-material";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { TokenPdf } from "./MailHelper";
import { BASE_URL } from "../../../Constants/baseConstant";
import { QRCodeCanvas } from "qrcode.react";
import { Logo } from "../../../../svg/Logo";
import React from "react";
import { reactSvgToBase64 } from "../../Base/helper/baseFunctions";




export default function TokenPreviewDialog({
  open = false,
  onClose = () => {},
  generatedToken = {},
  onPrint = () => {},
  onShareEmail = () => {},
  imageUrl=""
}) {
  const qrLogo = React.useMemo(() => reactSvgToBase64(Logo), []);
  const payload = {
      token_id: generatedToken?.token_id,
      domain_name: generatedToken?.domain_name,
      today: generatedToken?.today,
      user_id: generatedToken?.user_id,
      canteen_management_regions_pk:
        generatedToken?.canteen_management_regions_pk,
      company: generatedToken?.company
  };
  let token = btoa(JSON.stringify(payload));
  const portalLink = generatedToken?.region &&
    generatedToken?.uuid
      ? `${BASE_URL}/canteen-management-download-portal/${generatedToken?.region}/${token}`
      : "https://meepl.day";
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle
        disableTypography
        sx={{
          py: 2,
          background: "linear-gradient(135deg, #0f172a 0%, #111827 40%, #fecb03 100%)",
          color: "#fff",
          textAlign: "center",
          overflow: "hidden", 
          position: "relative"
        }}
      >
        <Box display="flex" alignItems="center" gap={1.5}>
          <QrCodeIcon fontSize="small" />
          <Typography variant="subtitle1" fontWeight={600}>
            Token Preview
          </Typography>
        </Box>
        {/* Top badge */}
          <Box
            sx={{
              position: "absolute",
              top: 8,
              right: -10,
              transform: "rotate(32deg) translateX(15px)",
              backgroundColor: "rgba(15,23,42,0.8)",
              px: 5,
              py: 0.5,
              fontSize: 10,
              fontWeight: 700,
              textTransform: "uppercase",
              letterSpacing: 1.3,
            }}
          >
            Meal Token
          </Box>
      </DialogTitle>

      <DialogContent dividers>
        {/* PRINT AREA START */}
        <Box
          id="token-print-area"
          sx={{
            background:
              "linear-gradient(135deg, #0f172a 0%, #111827 40%, #fecb03 100%)",
            borderRadius: 2,
            p: 2,
            color: "#f9fafb",
            boxShadow: "0 10px 25px rgba(15,23,42,0.4)",
            overflow: "hidden",
          }}
        >
          {/* Company + QR row */}
          <Grid container mb={1.5} mt={0.5}>
            <Grid item xs={12} md={6} mb={{xs: 1, md: 0}}>
              <Box>
                <Typography
                  variant="caption"
                  sx={{ opacity: 0.7, textTransform: "uppercase", letterSpacing: 1 }}
                >
                  {generatedToken?.company || "Company"}
                </Typography>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 700, lineHeight: 1.1, mt: 0.3 }}
                >
                  Canteen Pass
                </Typography>
              </Box>
              <Box mt={2}>
                <Typography
                  variant="caption"
                  sx={{ opacity: 0.7, textTransform: "uppercase", letterSpacing: 1 }}
                >
                  Token
                </Typography>
                <Typography variant="subtitle1" sx={{ fontWeight: 700, lineHeight: 1.1, mt: 0.3, pl: "4px" }}>
                  {generatedToken?.uuid || "-"}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  width: 180,
                  height: 180,
                  borderRadius: 2,  
                  border: "1px dashed rgba(249,250,251,0.5)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background:
                    "radial-gradient(circle at 30% 0%, rgba(254,203,3,0.3) 0, transparent 60%)",
                  mx: "auto",
                  }}
              >
                {/* <QRCodeCanvas
                  value={portalLink}
                  style={{
                    width: "94%",
                    height: "94%",
                  }}
                /> */}
                  <Box
                    sx={{
                      width: "94%",
                      height: "94%",
                      position: "relative",
                      borderRadius: "10px",
                      overflow: "hidden",
                      backgroundColor: "#fff",
                    }}
                  >
                    <QRCodeCanvas
                        value={portalLink}
                        level="H"         
                        bgColor="transparent" 
                        fgColor="#000000"
                        imageSettings={{
                          src: qrLogo,
                          height: 28,
                          width: 28,
                          excavate: true, 
                          borderRadius: 20
                        }}
                        style={{
                          width: "100%",
                          height: "100%",
                        }}
                      />
                  </Box>
              </Box>
              <Box>
                <Typography
                    variant="caption"
                    sx={{ opacity: 0.7, letterSpacing: 1, pl: 0.5 }}
                  >
                    Scan to Download Your Token
                  </Typography>
              </Box>
            </Grid>
          </Grid>
          <Divider sx={{ borderColor: "rgba(148,163,184,0.5)", my: 1.2 }} />
          {/* Employee info */}
          <Box display="flex" flexDirection="column" gap={0.2} mb={1.5}>
            <Box display="flex" alignItems="center" gap={0.5}>
                <PersonIcon sx={{ fontSize: 14, color: "#fff", opacity: 0.7  }} />
                <Typography
                  variant="caption"
                  sx={{ opacity: 0.7, textTransform: "uppercase", letterSpacing: 1 }}
                >
                  Employee
                </Typography>
              </Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 600, paddingLeft: "20px" }}>
                {generatedToken?.employee_name || "-"}
              </Typography>
          </Box>

          {/* Token details */}
          <Stack direction="row" spacing={1.5}>
            <Box display="flex" flexDirection="column" gap={0.2} flex={1}>
              <Box display="flex" alignItems="center" gap={0.5}>
                <AccountBalanceIcon sx={{ fontSize: 14, color: "#fff", opacity: 0.7  }} />
                <Typography
                  variant="caption"
                  sx={{ opacity: 0.7, textTransform: "uppercase", letterSpacing: 1 }}
                >
                  Count
                </Typography>
              </Box>
              <span style={{paddingLeft: "22px"}}>{generatedToken?.tokens || "0"}</span>
            </Box>
            <Box display="flex" flexDirection="column" gap={0.2}>
              <Box display="flex" alignItems="center" gap={0.5}>
                <AccountBalanceIcon sx={{ fontSize: 14, color: "#fff", opacity: 0.7 }} />
                <Typography
                  variant="caption"
                  sx={{ opacity: 0.7, textTransform: "uppercase", letterSpacing: 1 }}
                >
                  Token Balance
                </Typography>
              </Box>
              <span style={{paddingLeft: "22px"}}>{generatedToken?.token_balance || "-"}</span>
            </Box>
          </Stack>
        </Box>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "space-between", px: 3, py: 2 }}>
        <Stack direction="row" spacing={1}>
         {generatedToken?.tab === "Employee" && ( 
          <Button
            variant="outlined"
            size="small"
            startIcon={<ReceiptIcon />}
            onClick={onShareEmail}
          >
            Share via Mail
          </Button>)}

          <PDFDownloadLink
            document={
              <TokenPdf
                tokenCode={generatedToken?.uuid || ""}
                employeeName={generatedToken?.employee_name || ""}
                companyName={generatedToken?.company || ""}
                tokens={generatedToken?.tokens || "0"}
                region={generatedToken?.region || ""}
                imageUrl={imageUrl}
              />
            }
            fileName={`${generatedToken?.region}-${generatedToken?.uuid || "token"}.pdf`}
            style={{ textDecoration: "none" }}
          >
            {({ loading }) => (
              <Button
                variant="outlined"
                size="small"
                startIcon={<PrintIcon />}
                disabled={loading}
                onClick={onPrint}
              >
                Print Token
              </Button>
            )}
          </PDFDownloadLink>

        </Stack>

        <Button
          size="small"
          onClick={onClose}
          sx={{ textTransform: "none" }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}



